/**
 * API 接口监控工具
 * 用于监控特定接口的调用次数，检测循环调用等异常情况
 */

import tsignData from '@tsign/tsigndata-sdk-js'

// 监控配置
const MONITOR_CONFIG = {
  // /organizations/org-roles 接口配置
  '/accounts/sys_accountId/organizations/org-roles': {
    enabled: true, // 是否启用监控
    threshold: 3000, // 异常阈值（累计调用次数）
    currentCount: 0, // 当前累计调用次数
    reported: false, // 是否已上报（避免重复上报）
  },
}

/**
 * 记录接口调用
 * @param {string} url - 接口 URL
 * @returns {boolean} 是否触发异常
 */
export function trackApiCall(url) {
  // 查找匹配的监控配置
  const configKey = Object.keys(MONITOR_CONFIG).find(key => url.includes(key))

  if (!configKey) {
    return false // 无需监控的接口
  }

  const config = MONITOR_CONFIG[configKey]
  if (!config.enabled) {
    return false // 监控未启用
  }

  // 递增计数器
  config.currentCount++

  // 判断是否达到阈值
  if (config.currentCount >= config.threshold && !config.reported) {
    config.reported = true // 标记已上报，避免重复
    reportAnomaly(configKey, config.currentCount)
    return true
  }

  return false
}

/**
 * 上报异常
 * @param {string} apiName - 接口名称
 * @param {number} callCount - 累计调用次数
 */
function reportAnomaly(apiName, callCount) {
  const reportData = {
    apiName, // 接口名称
    callCount, // 累计调用次数
    pageUrl: window.location.href, // 当前页面 URL
    userAgent: navigator.userAgent, // 用户代理
    timestamp: new Date().toISOString(), // 时间戳
    projectName: 'billing-front', // 项目名称
  }

  // 调用神策埋点上报
  sendReport(reportData)
}

/**
 * 发送上报数据（使用神策埋点）
 * @param {Object} data - 上报数据
 */
async function sendReport(data) {
  try {
    // 使用 tsignData 进行神策埋点上报
    tsignData && tsignData.track('api_anomaly_detected', {
      api_name: data.apiName,
      call_count: data.callCount,
      page_url: data.pageUrl,
      user_agent: data.userAgent,
      project_name: data.projectName,
      timestamp: data.timestamp,
    })
    console.log('[API Monitor] 异常已通过神策上报:', data)
  } catch (error) {
    // 降级处理：上报失败时输出到控制台
    console.error('[API Monitor] 神策上报失败，降级输出:', data, error)
  }
}

/**
 * 重置监控计数（用于测试或手动重置）
 * @param {string} url - 接口 URL
 */
export function resetMonitor(url) {
  const configKey = Object.keys(MONITOR_CONFIG).find(key => url.includes(key))
  if (configKey) {
    MONITOR_CONFIG[configKey].currentCount = 0
    MONITOR_CONFIG[configKey].reported = false
    console.log('[API Monitor] 监控计数已重置:', configKey)
  }
}

/**
 * 获取监控状态（用于调试）
 * @param {string} url - 接口 URL
 * @returns {Object} 监控状态
 */
export function getMonitorStatus(url) {
  const configKey = Object.keys(MONITOR_CONFIG).find(key => url.includes(key))
  if (configKey) {
    return { ...MONITOR_CONFIG[configKey], apiName: configKey }
  }
  return null
}
